import { render, staticRenderFns } from "./ProductShow.vue?vue&type=template&id=389d2370&scoped=true&"
import script from "./ProductShow.vue?vue&type=script&lang=ts&"
export * from "./ProductShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d2370",
  null
  
)

export default component.exports